import { createFileRoute } from '@tanstack/react-router'
import {useDeliveredOrders} from "@state/server/orders.query.ts";
import {Container, LoadingOverlay, Tabs, Title} from '@mantine/core';
import OrdersTable from "@components/ordersTable.tsx";

export const Route = createFileRoute('/_authenticated/orders/_layout/delivered')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data, isLoading } = useDeliveredOrders()
  return <Tabs.Panel value={"delivered"}>
    <Container fluid>
      <Title order={2} py={"md"}>Historie objednávek</Title>

      <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{radius: "sm", blur: 2}} />
      {data && <OrdersTable orders={data}/>}
    </Container>

  </Tabs.Panel>
}
